import React, { Component } from "react";

const LINKS = [
  { label: "HOME",       href: "/" },
  { label: "ART",        href: "/art" },
  { label: "RESUME",     href: "/resume" },
  { label: "MEDIA CODE", href: "/lookup" },
  { label: "CONTACT",    href: "/contact" },
];

class Navbar extends Component {
  render() {
    const current = window.location.pathname;

    return (
      <div>

        <div className="App-header nav-root">
          <div className="leftHead"><p></p></div>
          <div>
            <div className="rowHead headlimit">
              {LINKS.map(({ label, href }) => {
                const isActive =
                  href === "/"
                    ? current === "/"
                    : current.startsWith(href);

                return (
                  <div
                    key={href}
                    className={`columnHead Homemid nav-link-item${isActive ? " active" : ""}`}
                    style={{ margin: "3px", marginLeft: "10px", marginRight: "10px" }}
                  >
                    <a href={href}>{label}</a>
                    {isActive && <span className="nav-active-dot" />}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;